
    var riot = require('riot')
    //src: starling/src/tags/node-menu.html
riot.tag2('node-menu',
  '<div class="floating-menu_list" ref="floatingMenuEl"> <menu-item-card-style></menu-item-card-style> <div class="separator-item floating-menu_item" onclick="{summonImageModal}" onmouseenter="{delayedHideSubMenus}"> <i class="material-icons floating-menu_icon">insert_photo</i> <span class="floating-menu_label">Media</span> </div> <menu-item-add-comment></menu-item-add-comment> <div class="floating-menu_divider"></div> <menu-item-attribute-editor></menu-item-attribute-editor> <div ref="perspectiveMenuItem" class="floating-menu_item" onmouseenter="{summonPerspectivesPanel}"> <i class="material-icons floating-menu_icon">visibility</i> <span class="floating-menu_label">Perspectives</span> <svg class="floating-menu_caret"> <use xlink:href="#caret-right-icon"></use> </svg> </div> <div class="floating-menu_divider"></div> <menu-item-create-waypoint onmouseenter="{delayedHideSubMenus}" classes="separator-item"></menu-item-create-waypoint> <div class="floating-menu_divider"></div> <div ref="layoutItem" class="floating-menu_item" onmouseenter="{summonLayoutMenu}"> <i ref="layoutIcon" class="toolbar-icons layout-vertical floating-menu_icon"></i> <span class="floating-menu_label">Layout</span> <svg class="floating-menu_caret"> <use xlink:href="#caret-right-icon"></use> </svg> </div> <menu-item-ungroup-system if="{showUngroupSystem()}" onmouseenter="{delayedHideSubMenus}"></menu-item-ungroup-system> <div hide="{!visibility.popOut}" class="floating-menu_item" onmouseenter="{delayedHideSubMenus}" onclick="{toggleChildrenAttachment}" data-track="Node Menu" data-track-action="Pop-out-Selection" data-track-label="Selection"> <svg class="floating-menu_icon"> <use xlink:href="#pop-out-icon"></use> </svg> <span class="floating-menu_label">Pop-out Parts</span> </div> <div hide="{!visibility.popIn}" class="floating-menu_item" onmouseenter="{delayedHideSubMenus}" onclick="{toggleChildrenAttachment}" data-track="Node Menu" data-track-action="Pop-in-Selection" data-track-label="Selection"> <svg class="floating-menu_icon"> <use xlink:href="#pop-in-icon"></use> </svg> <span class="floating-menu_label">Pop-in Parts</span> </div> <div hide="{!visibility.emancipatePart}" class="floating-menu_item floating-menu_item--iconless" onmouseenter="{delayedHideSubMenus}" onclick="{emancipatePart}" data-track="Node Menu" data-track-action="Detach-Selection" data-track-label="Selection"> <span class="floating-menu_label">Detach {nodeHasLink ? \'Card\' : \'Part\'}</span> </div> <div if="{visibility.popOut || visibility.popIn || visibility.emancipatePart}" class="floating-menu_divider"></div> <div class="floating-menu_item" onmouseenter="{delayedHideSubMenus}" onclick="{deleteNode}" data-track="Node Menu" data-track-action="Delete-Selection" data-track-label="Selection"> <i class="material-icons floating-menu_icon">delete</i> <span class="floating-menu_label">Delete card</span> </div> </div>',
  '',
  'class="floating-menu floating-menu--hidden"', function(opts) {
'use strict';

var _this = this;

var _util = require('lib/util');

var _constants = require('lib/constants');

var _perspectivesUi = require('lib/perspectives-ui');

var _relationshipUi = require('lib/relationship-ui');

var _nodesUi = require('lib/nodes-ui');

var _menuUi = require('lib/menu-ui');

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

var _store_instance = require('../store_instance');

var _store_instance2 = _interopRequireDefault(_store_instance);

var _delayHandler = require('lib/delay-handler');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

this.canvas = this.opts.canvas;
this.canvas.nodeMenuTag = this;
this.operation = this.parent.operation;
this.visibility = {};
this.toLeft = false;
this.colorChoices = _constants.CARD_COLORS;
this.menuName = 'node-menu';
this.setDisplayedLayout = _menuUi.mui.setDisplayedLayout.bind(this);
this.positionSelf = _menuUi.mui.positionSelf.bind(this);
this.singleCardMenu = true;

this.on('mount', function () {
  _this.canvas.nodeMenuTag = _this;
  $(_this.root).on('mousedown touchstart pointerdown', function (e) {
    e.stopImmediatePropagation();
  });
});

this.on('updated', _eventTracking2.default.listen(this.root));

var shuttle = function shuttle(localRef, remoteRef) {
  if (!(localRef && localRef.parentNode && remoteRef)) {
    return;
  }
  localRef.parentNode.removeChild(localRef);
  remoteRef.appendChild(localRef);
  localRef.classList.remove('hidden');
};

this.summon = function (_ref) {
  var node = _ref.node,
      tag = _ref.tag,
      childNodes = _ref.childNodes,
      referenceEl = _ref.referenceEl;

  _this.canvas.hidePopups({ keepNodeTools: true });
  for (var _iterator = _this.root.querySelectorAll("option"), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref2;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref2 = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref2 = _i.value;
    }

    var el = _ref2;

    el.selected = false;
  }
  tag = tag || node;

  var _canvas$getMatrix = _this.canvas.getMatrix(),
      scale = _canvas$getMatrix.scale,
      tx = _canvas$getMatrix.tx,
      ty = _canvas$getMatrix.ty;

  _this.summoned = true;
  _this.node = node;
  _this.tag = tag;
  _this.root.classList.remove('floating-menu--hidden');
  _this.childNodes = childNodes;
  _this.root.classList.remove('child-nodes-menu');
  if (childNodes) {
    _this.root.classList.add('child-nodes-menu');
  }
  var hasChildren = _this.node.hasChildren();
  _this.hasChildren = hasChildren;
  _this.visibility = {
    popOut: hasChildren && !node.instance.childrenDetached,
    popIn: hasChildren && node.instance.childrenDetached,
    emancipatePart: node.instance.getParent() || node.instance.link()
  };

  _this.selected = {
    popIn: node.instance.childrenDetached ? 'selected' : '',
    popOut: node.instance.childrenDetached ? 'selected' : ''
  };

  _this.nodeTag = _this.canvas.nodeTags[node.id];
  if (_this.nodeTag && _this.nodeTag.refs.container) {
    _this.nodeTag.refs.container.classList.add('no-fade');
  }
  _this.nodeHasLink = node.instance.link();
  _this.hideSubMenus();
  _this.update();

  var layoutName = node.instance.getLayoutName();
  _this.setDisplayedLayout(layoutName);

  _this.positionSelf({ referenceEl: referenceEl, selfEl: _this.refs.floatingMenuEl });
};

this.hide = function () {
  if (_this.nodeTag && _this.nodeTag.refs.container) {
    _this.nodeTag.refs.container.classList.remove('no-fade');
    _this.nodeTag.removeHoveredState();
  }
  _this.summoned = false;
  _this.tag = null;
  _this.node = null;
  _this.nodeTag = null;
  _this.root.classList.add('floating-menu--hidden');
  _this.root.classList.remove('child-nodes-menu');
  _this.hideSubMenus();
  _this.canvas.nodePerspectivesPanelTag.clearInput();
};

this.getSelectedNodeIds = function () {
  if (_this.tag) {
    return [_this.tag.id];
  }

  return [];
};

this.summonTagPopover = function (e) {
  e.stopPropagation();
  _this.hideSubMenus(e);
  if (_this.positionSubToLeft) {
    _this.canvas.tagPopoverTag.summonToMenu(_this.tag, _this, true);
  } else {
    _this.canvas.tagPopoverTag.summonToMenu(_this.tag, _this, false);
  }
};

this.setDisplayStyle = function (_ref3) {
  var style = _ref3.style;
  var node = _this.node;
  var instance = node.instance,
      nodeUUID = node.id;

  var prevStyle = instance.getDisplayStyle();

  instance.setDisplayStyle(style);

  _this.operation.setNodeDisplayStyle({
    nodeUUID: nodeUUID,
    prevStyle: prevStyle,
    style: style
  });

  node.updateDescendants();

  _this.update();
};

this.getSelectedColor = function () {
  if (!_this.node || !_this.node.instance) return '';
  return _this.node.instance.getBackgroundColor();
};

this.getSelectedStyle = function () {
  if (!_this.node || !_this.node.instance) return '';
  return _this.node.instance.getDisplayStyle();
};

this.closeColorPicker = function () {
  _this.tags['menu-item-card-style'].hideSubMenu();
};

this.setColor = function (color) {
  var node = _this.node;

  _menuUi.mui.setCardColor(color, [node.id]);

  node.update({ forceUpdate: true });
  _this.update();
};

this.addPart = function (e) {
  e.stopPropagation();
  _this.canvas.lastNodeCreatedWithEnterKey = null;
  _this.node.addPart(undefined, undefined, true);
};

this.createRelationship = function (e) {
  e.stopPropagation();

  var selectedNodes = _this.canvas.getSelectedNodes();

  if (selectedNodes.length) {
    var toNodes = selectedNodes.filter(function (n) {
      return n.id != _this.node.id;
    });
    if (toNodes.length) {
      // create links to all selected cards
      _relationshipUi.rui.createLinksToNodes(_this.node, toNodes);
      _this.canvas.nodeTools.hide();
      _this.hide();
      return;
    }
  }
  // start R line creation on cursor
  _relationshipUi.rui.startCreation(_this.tag);
  _this.canvas.nodeTools.hide();
  _this.hide();
};

this.summonPerspectivesPanel = function (e) {
  e.stopPropagation();
  _delayHandler.delayHandler.initializeDelay({
    action: 'submenus',
    id: 'perspectives',
    delay: _constants.MENU_OPEN_DELAY,
    callback: function callback() {
      _this._summonPerspectivesPanel(e);
    }
  });
};

this._summonPerspectivesPanel = function (e) {
  _this.hideSubMenus(e);
  if (_this.positionSubToLeft) {
    _this.canvas.nodePerspectivesPanelTag.summon({
      tag: _this.tag,
      referenceEl: _this.refs.perspectiveMenuItem,
      isBulkAction: false,
      positionToLeft: true,
      isLink: false,
      origin: _this.menuName
    });
  } else {
    _this.canvas.nodePerspectivesPanelTag.summon({
      tag: _this.tag,
      referenceEl: _this.refs.perspectiveMenuItem,
      isBulkAction: false,
      isLink: false,
      origin: _this.menuName
    });
  }
};

this.delayedHideSubMenus = function () {
  _delayHandler.delayHandler.initializeDelay({
    action: 'submenus',
    id: 'hide',
    delay: _constants.MENU_OPEN_DELAY,
    callback: function callback() {
      _this.hideSubMenus();
    }
  });
};

this.hideSubMenus = function () {
  var canvas = _this.canvas,
      menuName = _this.menuName;

  if (canvas.nodeLayoutMenuTag.fromOrigin(menuName)) canvas.nodeLayoutMenuTag.hide();
  if (canvas.nodePerspectivesPanelTag.fromOrigin(menuName)) canvas.nodePerspectivesPanelTag.hide();
  if (canvas.exportMenu.fromOrigin(menuName)) canvas.exportMenu.hide();
  if (canvas.nodeAttributeEditor.fromOrigin(menuName)) canvas.nodeAttributeEditor.hide();
  canvas.nodeAlignContentMenuTag.hide();
  _this.closeColorPicker();
};

this.summonImageModal = function (e) {
  e.stopPropagation();
  _this.hideSubMenus(e);
  var node = _store_instance2.default.getNode(_this.node.id);
  if (node.attachedFile) {
    _this.canvas.imageModal.triggerEdit(node.id);
  } else {
    _this.canvas.imageModal.show(node.id);
  }
};

this.deleteNode = function (e) {
  e.stopPropagation();
  e.preventDefault();
  _this.canvas.deleteNode(_this.node.id);
  _this.canvas.hidePopups();
  _this.hide();
};

this.toggleChildrenAttachment = function (e) {
  e.stopPropagation();
  if (_this.node.instance.getChildrenDetached()) {
    _this.attachChildren();
  } else {
    _this.detachChildren();
  }

  _this.hide();
};

this.attachChildren = function () {

  _this.node.instance.setChildrenDetached(false);
  _this.node.updateChildDetachment(_this.node.id);
  if (_this.node.childNodesTag) {
    _this.node.childNodesTag.update();
  }
  _this.node.updateTopLevelNeighborsLite();

  var messages = [];

  var _nui$fixOverlaps = _nodesUi.nui.fixOverlaps({
    nodeTag: _this.node,
    allowedDirections: ['right', 'down']
  }),
      prevNodePositions = _nui$fixOverlaps.prevNodePositions,
      nodePositions = _nui$fixOverlaps.nodePositions;

  if (nodePositions.length) {
    messages.push(self.operation.messages.updateNodePositions({
      prevNodePositions: prevNodePositions,
      nodePositions: nodePositions,
      prevLinkAngles: [],
      linkAngles: []
    }));
  }

  messages.push(_this.operation.messages.setChildrenDetached({
    nodeUUID: _this.node.id,
    detached: false,
    x: _this.node.childrenPosition.x,
    y: _this.node.childrenPosition.y
  }));

  _this.operation.batchOperation({
    messages: messages,
    onFailure: function onFailure(err) {
      console.warn('attach children batchOperation failed: ' + err);
    }
  });
};

this.detachChildren = function () {
  // Note: for some reason, calling this.node.discoverPosition() doesn't set node.width from here.
  // are function calls from other tags run asynchronously?

  // make sure we have a width (especially for R nodes)
  var width = _this.node.width;
  if (width === undefined) {
    var rect = _this.node.refs.container.getBoundingClientRect();

    var _self$canvas$getMatri = self.canvas.getMatrix(),
        scale = _self$canvas$getMatri.scale,
        tx = _self$canvas$getMatri.tx,
        ty = _self$canvas$getMatri.ty;

    width = (rect.right - rect.left) / scale;
  }

  // don't need to place popout too far way (text wraps at 265px)
  var node = _store_instance2.default.getNode(_this.node.id);
  var x = void 0;
  var y = void 0;
  if (!node.childrenPosition || node.childrenPosition.x === undefined || node.childrenPosition.y === undefined) {
    x = Math.min(275, width + 40);
    y = -60;
    node.setChildrenPosition({ x: x, y: y });
  }

  _this.node.instance.setChildrenDetached(true);
  _this.node.updateChildDetachment(_this.node.id);
  _this.node.childNodesTag.update();
  _this.node.childNodesTag.updatePosition();
  _this.node.updateTopLevelNeighborsLite();
  _this.node.childNodesTag.updateShadow();
  _this.node.childNodesTag.enableDragging();

  _this.operation.setChildrenDetached({
    nodeUUID: _this.node.instance.id,
    detached: true,
    x: x,
    y: y,
    onFailure: function onFailure(err) {
      console.warn('setChildrenDetached failed');
    }
  });
};

this.emancipatePart = function (e) {
  var node = _store_instance2.default.getNode(_this.node.id);
  var link = node.link();
  if (link) {
    var prevLink = Object.assign({}, link);
    link.setLinkNodeId(null);
    _this.operation.setLinkNodeId({
      link: link,
      prevLink: prevLink,
      onFailure: function onFailure(err) {
        return console.log(err);
      }
    });
    _this.node.updateTopLevelNeighborsLite();
    _this.canvas.linkTags[link.id].removeClipPolygon();
    _this.hide();
    return;
  }
  var prevNodePositions = _store_instance2.default.getNodePositions([node.id]);

  var _canvas$getMatrix2 = _this.canvas.getMatrix(),
      scale = _canvas$getMatrix2.scale,
      tx = _canvas$getMatrix2.tx,
      ty = _canvas$getMatrix2.ty;

  var topParent = node.getTopLevelParent();
  var nodeRect = _this.node.refs.container.getBoundingClientRect();
  var topParentRect = _this.canvas.nodeTags[topParent.id].refs.container.getBoundingClientRect();
  var closestEdge = (nodeRect.left + nodeRect.right) / 2 < (topParentRect.left + topParentRect.right) / 2 ? 'left' : 'right';

  if (node.getGoverningLayoutName() !== 'layout-freehand') closestEdge = 'left';
  var oldParentId = node.parentId;

  var formerParent = _this.canvas.nodeTags[node.parentId];

  node.setOrderIndex(0);
  node.setParentId(null);
  nodeRect = _this.node.refs.container.getBoundingClientRect();

  canvas.nodeTags[oldParentId].updateTopLevelNeighborsLite();
  canvas.nodeTags[node.id].updateLayers();
  canvas.nodesTag.update();
  canvas.nodeTags[oldParentId].topLevelParentTag().rediscoverLinkPositions();
  _this.hide();
  topParentRect = _this.canvas.nodeTags[topParent.id].refs.container.getBoundingClientRect();

  var newXPos = void 0;
  if (closestEdge === 'left') {
    newXPos = topParentRect.left - nodeRect.width - 20;
  } else {
    newXPos = topParentRect.right + 20;
  }

  node.setAbsolutePosition({
    x: (newXPos - tx) / scale,
    y: (e.clientY - ty - 26) / scale
  });
  node.setPosition({
    x: (newXPos - tx) / scale,
    y: (e.clientY - ty - 26) / scale
  });

  canvas.nodeTags[node.id].updateTopLevelNeighborsLite();

  var nodePositions = _store_instance2.default.getNodePositions([node.id]);

  var overlaps = _nodesUi.nui.fixOverlaps({ nodeTag: _this.canvas.nodeTags[node.id] });

  var operationMessages = [];
  operationMessages.push(_this.operation.messages.updateNodePositions({
    prevNodePositions: prevNodePositions.concat(overlaps.prevNodePositions),
    nodePositions: nodePositions.concat(overlaps.nodePositions),
    prevLinkAngles: [],
    linkAngles: [],
    selectedNodes: [node.id, formerParent.id]
  }));

  var oldParent = _store_instance2.default.getNode(oldParentId);
  if (oldParent.getLayoutName() === 'layout-freehand') {
    if (oldParent.children().length < 1) {

      oldParent.setLayoutName('layout-row');

      operationMessages.push(_this.operation.messages.setNodeLayoutName({
        nodeUUID: oldParentId,
        prevLayoutName: 'layout-freehand',
        layoutName: 'layout-row'
      }));
    }
  }

  _this.operation.batchOperation({
    messages: operationMessages,
    onFailure: function onFailure(err) {
      console.warn('emancipatePart batchOperation failed: ' + err);
    }
  });

  //add in some animation here later
  /* const container = this.node.refs.container; */
  /* /1* container.classList.remove('emancipating'); *1/ */
  /* container.classList.add('emancipating'); */

  _this.canvas.nodeTags[node.id].child = false;

  _this.hide();
};

this.setLayout = function (layoutName) {
  var childNodes = _this.node.childNodesTag;

  var prevLayoutName = _this.node.layoutName;
  var operationMessages = [];
  if (layoutName == 'layout-freehand') {
    var preserveLayout = false;
    var node = _store_instance2.default.getNode(_this.node.id);
    var targetNodeIds = node.children().map(function (_ref4) {
      var id = _ref4.id;
      return id;
    });
    var _prevNodePositions = _store_instance2.default.getNodePositions(targetNodeIds);

    for (var _iterator2 = node.children(), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref5;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref5 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref5 = _i2.value;
      }

      var _child = _ref5;

      if (_child.x !== 0 || _child.y !== 0) {
        preserveLayout = true;
        break;
      }
    }

    if (!preserveLayout) {
      var px = null,
          py = null;

      var i = 0;
      for (var _iterator3 = node.children(), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
        var _ref6;

        if (_isArray3) {
          if (_i3 >= _iterator3.length) break;
          _ref6 = _iterator3[_i3++];
        } else {
          _i3 = _iterator3.next();
          if (_i3.done) break;
          _ref6 = _i3.value;
        }

        var child = _ref6;

        // slightly skew and spread children from where they were
        var hJitter = i % 2 == 1 && node.getLayoutName() == 'layout-row' ? 10 : 0;
        var vJitter = i % 2 == 1 && node.getLayoutName() == 'layout-col' ? 10 : 0;
        var scale = 1.1;
        var hpad = 10;
        var vpad = 20;
        var dx = (child.absolutePosition.x - node.absolutePosition.x) * scale + hJitter;
        var dy = (child.absolutePosition.y - node.absolutePosition.y) * scale + vJitter;
        if (px === null && py === null) {
          px = dx + 0;
          py = dy + 0;
        }
        child.x = dx - px + hpad;
        child.y = dy - py + vpad;
        i++;
      }

      operationMessages.push(_this.operation.messages.updateNodePositions({
        prevNodePositions: _prevNodePositions,
        prevLinkAngles: [],
        nodePositions: _store_instance2.default.getNodePositions(targetNodeIds),
        linkAngles: [],
        selectedNodes: [_this.node.id]
      }));
    }
  }

  _this.node.instance.setLayoutName(layoutName);
  childNodes.refs.childNodes.classList.remove('layout-row', 'layout-freehand', 'layout-col');
  childNodes.refs.childNodes.classList.add(layoutName);
  _this.canvas.nodesTag.update();
  _this.node.updateLayers();
  _this.node.updateTopLevelNeighborsLite();
  (0, _util.refreshFreehandAncestorsOfList)([_this.node.id], _this.canvas, _store_instance2.default);
  var main = _this.node.childNodesTag.refs.main;

  //if (layoutName == 'layout-freehand') {
  main.classList.add("loosening");
  setTimeout(function () {
    main.classList.remove('loosening');
  }, 3000);
  //}
  childNodes.fitToContents();
  childNodes.updateShadow();

  var _nui$fixOverlaps2 = _nodesUi.nui.fixOverlaps({
    nodeTag: _this.node,
    allowedDirections: ['right', 'down']
  }),
      prevNodePositions = _nui$fixOverlaps2.prevNodePositions,
      nodePositions = _nui$fixOverlaps2.nodePositions;

  if (nodePositions.length) {
    operationMessages.push(self.operation.messages.updateNodePositions({
      prevNodePositions: prevNodePositions,
      nodePositions: nodePositions,
      prevLinkAngles: [],
      linkAngles: []
    }));
  }

  operationMessages.push(_this.operation.messages.setNodeLayoutName({
    nodeUUID: _this.node.id,
    prevLayoutName: prevLayoutName,
    layoutName: layoutName
  }));

  _this.operation.batchOperation({
    messages: operationMessages,
    onFailure: function onFailure(err) {
      console.log('setLayout batchOperation failure: ' + err);
    }
  });

  _this.hide();
};

this.openExportMenu = function () {
  _this.hideSubMenus();
  _this.canvas.exportMenu.summon({
    exportNode: _this.tag,
    spawnedFromElement: _this.refs.exportOption,
    origin: _this.menuName
  });
};

this.summonLayoutMenu = function () {
  _delayHandler.delayHandler.initializeDelay({
    action: 'submenus',
    id: 'layout',
    delay: _constants.MENU_OPEN_DELAY,
    callback: function callback() {
      _this.hideSubMenus();
      _this.canvas.nodeLayoutMenuTag.summon({
        referenceEl: _this.refs.layoutItem,
        positionToLeft: _this.positionSubToLeft,
        tag: _this.node,
        origin: _this.menuName
      });
    }
  });
};

this.summonAlignMenu = function () {
  _delayHandler.delayHandler.initializeDelay({
    action: 'submenus',
    id: 'align',
    delay: _constants.MENU_OPEN_DELAY,
    callback: function callback() {
      _this.hideSubMenus();
      _this.canvas.nodeAlignContentMenuTag.summon({
        referenceEl: _this.refs.alignItem,
        positionToLeft: _this.positionSubToLeft,
        tag: _this.node,
        origin: _this.menuName
      });
    }
  });
};

this.justificationIcon = function () {
  if (!_this.node) return 'left';
  var node = _this.canvas.store.getNode(_this.node.id);

  return node.getJustification();
};

this.cardColorStyle = function () {
  return (0, _util.getStyleColorVariables)({
    color: _this.getSelectedColor(),
    style: _this.getSelectedStyle()
  });
};

this.showUngroupSystem = function () {
  return _this.getSelectedNodeIds().some(function (id) {
    return _store_instance2.default.getNode(id).children().length;
  });
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('node-menu')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/node-menu.html
// module id = 622
// module chunks = 0